import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'
import { queryClient } from "../../..";

export default async function deleteProduto(BotijaoId: number) {
  return await api.delete(`${URLS.BOTIJAO_API}/${BotijaoId}`)
  .then((response : any) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Botijão apagado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then(()=> {
      queryClient.invalidateQueries()
    })
    return response;
  })
  .catch((err : any) => {
    console.log(err.message);
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}